<div class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div class="widget-wrapper" style="min-height: 100%" [ngStyle]="borderStyle">
    <div class="form-wrapper">
      <form
        [formGroup]="nameForm"
        class="finxForm"
        [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
      >
        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <ng-container
              *ngTemplateOutlet="nameInput; context: { field: field, formGroup: nameForm }"
            ></ng-container>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #nameInput let-field="field" let-formGroup="formGroup" let-index="index">
  <div [formGroup]="formGroup">
    <finxone-input
      [id]="field?.name"
      [type]="field.type"
      [label]="field.label"
      [formControlName]="field?.name"
      [disableAutocomplete]="disableAutocomplete"
      [formControlInvalid]="
        !!(nameForm?.controls?.[field?.name]?.touched && nameForm?.controls?.[field?.name]?.invalid)
      "
      [value]="nameForm?.get(field.name)?.value ?? ''"
    >
    </finxone-input>
    <div class="error-wrapper typog-xs mt-1">
      <div
        class="text-error"
        *ngIf="nameForm?.get(field.name)?.invalid && nameForm?.get(field.name)?.touched"
      >
        <p *ngIf="nameForm?.get(field.name)?.hasError('required') && field.name === 'firstName'">
          {{ validationMessages.required('First name') }}
        </p>
        <p *ngIf="nameForm?.get(field.name)?.hasError('required') && field.name === 'lastName'">
          {{ validationMessages.required('Last name') }}
        </p>
        <p *ngIf="nameForm?.get(field.name)?.hasError('noNumbers')">
          {{ validationMessages.noNumbers(field.label) }}
        </p>
        <p *ngIf="nameForm?.get(field.name)?.hasError('noSpecialChars')">
          {{ validationMessages.noSpecialChars(field.label) }}
        </p>
      </div>
    </div>
  </div>
</ng-template>
